import React from 'react';
import { Routines } from '../components';
import { useNavigate } from "react-router-dom";
import { withRouter } from 'us.common/wIthRouter';

interface ICnt_Routines  {

}


const Cnt_Routines = (props: ICnt_Routines) => {
    const navigate = useNavigate();
    const onMinimize = () => {
        navigate('')
    }

    return (
        <Routines.Home onMinimize={onMinimize} />
    )
}

export default withRouter(Cnt_Routines);